var exports = {
  "Y8": "reviewListItem__7LJsxF",
  "FC": "reviewTitle__zqlkGW",
  "e3": "reviewAuthor__uJbX3E",
  "Pe": "reviewAuthorAnchor__LTcahN",
  "h3": "reviewerAvatar__rFfpUa",
  "Hh": "reviewedIcon__LvT16i",
  "TL": "reviewerGroupsContainer__bY2cAd",
  "aP": "reviewText__e0KM1u",
  "lY": "reviewerActionBar__8jZJvM",
  "RA": "subtitleLink__P6cO2l",
};

module.exports = exports;
